var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSgd = function SvgSgd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.031 20c5.534 0 10-4.467 10-10h-20c0 5.533 4.467 10 10 10Z",
    fill: "#F9F9F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.031 0c-5.533 0-10 4.467-10 10h20c0-5.533-4.466-10-10-10Z",
    fill: "#ED4C5C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m6.431 5.167-.4-.334h.5l.167-.5.167.5h.5l-.4.334.133.5-.4-.3-.4.3.133-.5ZM9.098 5.167l-.4-.334h.5l.166-.5.167.5h.5l-.4.334.133.5-.4-.3-.4.3.134-.5ZM6.764 6.833l-.4-.333h.5l.167-.5.167.5h.5l-.4.333.133.5-.4-.3-.4.3.133-.5ZM8.764 6.833l-.4-.333h.5l.167-.5.167.5h.5l-.4.333.133.5-.4-.3-.4.3.133-.5ZM7.764 4.167l-.4-.334h.5l.167-.5.167.5h.5l-.4.334.133.5-.4-.3-.4.3.133-.5Z",
    fill: "#F9F9F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.498 8.667c-1.6 0-2.867-1.367-2.867-3.034 0-1.666 1.3-3.033 2.867-3.033.133 0 .233 0 .333.033-.4-.2-.833-.3-1.3-.3-1.733 0-3.166 1.5-3.166 3.334C3.365 7.5 4.798 9 6.53 9c.534 0 1.067-.133 1.5-.4-.167.033-.333.067-.533.067Z",
    fill: "#F9F9F9"
  })));
};
export default SvgSgd;